import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AttributeEditSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AttributeEditSVG;
